import BaseViewController from "./base-view-controller";
import pharmacyValidation from "./helpers/templated-pharmacy-validation";

class MyPharmaciesViewController extends BaseViewController {
  formState = {};

  prepareSubmit(values) {
    return { ...values, ...this.formState };
  }

  handleButtonClick(name, text, action, ...[, , eventStates]) {
    if (eventStates?.length) {
      this.updateStates(eventStates, true);
      return;
    }

    if (name === "submit" && action.data) {
      this.mapActionDataParams(action);
    }

    if (action?.value) {
      super.handleButtonClick(name, text, action);
    }
  }

  mapActionDataParams = action => {
    const {
      data: { pharmacy_id, pharmacyView, selectedData }
    } = action;

    this.formState = {
      selectedData,
      pharmacy_id,
      pharmacy_view: pharmacyView
    };
    delete action.data;
  };
}

MyPharmaciesViewController.fieldValidation = pharmacyValidation;

export default MyPharmaciesViewController;
